var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-value-props",
      style: {
        "background-color": _vm.schema.settings.backgroundColorProductValueProps
      }
    },
    [
      _c("div", { staticClass: "container" }, [
        _vm.schema.blocks[3].settings.title
          ? _c(
              "div",
              { staticClass: "product-value-prop-container" },
              _vm._l(_vm.schema.blocks, function(block) {
                return _c(
                  "div",
                  { key: block.id, staticClass: "product-value-prop" },
                  [
                    block.settings.title && block.settings.body
                      ? _c(
                          "div",
                          { staticClass: "product-value-prop__content" },
                          [
                            _c(
                              "div",
                              { staticClass: "product-value-prop__icon" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: block.settings.icon,
                                    alt: block.settings.icon
                                  }
                                })
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "product-value-prop__text" },
                              [
                                block.settings.title
                                  ? _c(
                                      "h4",
                                      {
                                        staticClass: "product-value-prop__title"
                                      },
                                      [_vm._v(_vm._s(block.settings.title))]
                                    )
                                  : _vm._e(),
                                block.settings.body
                                  ? _c("p", {
                                      staticClass:
                                        "product-value-prop__body body-md",
                                      domProps: {
                                        innerHTML: _vm._s(block.settings.body)
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          : _c(
              "div",
              { staticClass: "product-value-prop-container" },
              _vm._l(_vm.schema.blocks.slice(0, 3), function(block) {
                return _c(
                  "div",
                  { key: block.id, staticClass: "product-value-prop" },
                  [
                    block.settings.title && block.settings.body
                      ? _c(
                          "div",
                          { staticClass: "product-value-prop__content" },
                          [
                            _c(
                              "div",
                              { staticClass: "product-value-prop__icon" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: block.settings.icon,
                                    alt: block.settings.icon
                                  }
                                })
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "product-value-prop__text" },
                              [
                                block.settings.title
                                  ? _c(
                                      "h4",
                                      {
                                        staticClass: "product-value-prop__title"
                                      },
                                      [_vm._v(_vm._s(block.settings.title))]
                                    )
                                  : _vm._e(),
                                block.settings.body
                                  ? _c("p", {
                                      staticClass:
                                        "product-value-prop__body body-md",
                                      domProps: {
                                        innerHTML: _vm._s(block.settings.body)
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              }),
              0
            )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }